import React, { useState } from 'react';
import { ChevronDownIcon, SparklesIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { rewardVisibleTo } from '../../utils/rewards';
import { formatDate } from '../../utils/time';

/** Kozarec goodies: stanje, najbližja nagrada in (na zahtevo) zgodovina. */
export function GoodiesJarCard({
  memberId
}: {
  memberId: string;
}) {
  const {
    family,
    db,
    balanceOf,
    bonusTodayFor
  } = useAppState();
  const [showHistory, setShowHistory] = useState(false);
  const balance = balanceOf(memberId);
  const today = bonusTodayFor(memberId);
  const tx = db.ledger.filter(t => t.familyId === family.id && t.memberId === memberId).slice(0, 8);
  const rewards = family.rewards.filter(r => rewardVisibleTo(r, memberId)).sort((a, b) => a.cost - b.cost);
  const next = rewards.find(r => r.cost > balance) ?? null;
  const affordable = rewards.filter(r => r.cost <= balance).length;
  const pct = next ? Math.min(100, Math.round(balance / next.cost * 100)) : 100;
  return <section aria-labelledby={`jar-${memberId}`} className="rounded-3xl bg-bonus-soft p-5" data-id="element-311" data-mp="1pa0lps7wk5le">
      <h2 id={`jar-${memberId}`} className="flex items-center gap-2 font-display text-lg text-bonus-ink" data-id="element-312" data-mp="1l96w8uetaiqe">
        <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-313" data-mp="1z0v9j10srd8y" /> Goodies
      </h2>
      <p className="mt-1 font-display text-5xl tabular-nums leading-none text-bonus-ink" data-id="element-314" data-mp="1u7iwlo5hcuw1">{balance}</p>

      {rewards.length > 0 && <div className="mt-4" data-id="element-315" data-mp="28zktr0g619sd">
          {affordable > 0 && <p className="text-sm font-extrabold text-bonus-ink" data-id="element-316" data-mp="23xbzm0rk41oo">
              Lahko že izbereš {affordable === 1 ? '1 nagrado' : `${affordable} nagrade`}!
            </p>}
          {next && <>
              <p className="mt-1 text-sm font-bold text-bonus-ink" data-id="element-317" data-mp="2czuwm48nvk30">
                Še {next.cost - balance} do: {next.title}
              </p>
              <div className="mt-2 h-2.5 overflow-hidden rounded-full bg-surface" aria-hidden="true" data-id="element-318" data-mp="ilak4euhuuup">
                <div className="h-full rounded-full bg-bonus" style={{
            width: `${pct}%`
          }} data-id="element-319" data-mp="2intijlmtswh8" />
              </div>
            </>}
        </div>}

      <button type="button" onClick={() => setShowHistory(s => !s)} aria-expanded={showHistory} className="mt-4 inline-flex items-center gap-1 text-xs font-extrabold text-bonus-ink hover:underline" data-id="element-320" data-mp="2noh802vep59c">
        Kje sem jih dobil(a) <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform duration-150 ${showHistory ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-321" data-mp="31l4jdao3vxys" />
      </button>
      {showHistory && <ul className="mt-2 space-y-1.5 border-t border-bonus/20 pt-2 text-sm text-bonus-ink" data-id="element-322" data-mp="3bbfo2zfm6b6q">
          {today.map(l => <li key={l.reason} className="flex justify-between gap-3" data-id="element-323" data-mp="3g9qxj91zyjof">
              <span className="min-w-0" data-id="element-324" data-mp="3kd5lqn03a6cy">Danes · {l.reason}</span>
              <span className="shrink-0 font-bold" data-id="element-325" data-mp="3kasypvfh55t1">+{l.amount}</span>
            </li>)}
          {tx.map(t => <li key={t.id} className="flex justify-between gap-3" data-id="element-326" data-mp="1dowmae9ib25s">
              <span className="min-w-0" data-id="element-327" data-mp="1dm0ocpxnsdhc">
                {formatDate(t.date)} · {t.reason}
              </span>
              <span className="shrink-0 font-bold" data-id="element-328" data-mp="14np1myzwxzu6">{t.amount > 0 ? `+${t.amount}` : t.amount}</span>
            </li>)}
          {today.length === 0 && tx.length === 0 && <li data-id="element-329" data-mp="zqgfknbn9bnn">Še nič. Poglej goodies priložnosti na zaslonu Danes.</li>}
        </ul>}
    </section>;
}